module.exports = __webpack_public_path__ + "img/arrow-right-grey.67aac10a.png";